import { TimeSlotLabel } from "../components/bookingflow/timeSlotLabel"

let labelKeys = Object.keys(TimeSlotLabel)
let labelsSet = {}
labelKeys.forEach(key => {
	let label = TimeSlotLabel[key]
	labelsSet[label.id] = label
})

export const normalizeTimeSlots = (timeSlots, labels) => {

	let normalizedTimeSlots = {}

	timeSlots.forEach((dayTimeSlots) => {
		if (dayTimeSlots.time_slots.length > 0) {
			normalizedTimeSlots[dayTimeSlots.delivery_date] = {}

			dayTimeSlots.time_slots.forEach((timeSlot) => {
				let label = timeSlot.label
				if (!(label in normalizedTimeSlots[dayTimeSlots.delivery_date])) {
					normalizedTimeSlots[dayTimeSlots.delivery_date][label] = []
				}
				normalizedTimeSlots[dayTimeSlots.delivery_date][label].push(normalizeTimeSlot(timeSlot, labels[timeSlot.worker_details.worker_contract_id]))
			})
		}
	})

	return normalizedTimeSlots
}

const normalizeTimeSlot = (timeSlot, labels) => {
	let l = []
	let addedLabels = []

	if (labels !== undefined) {
		labels.forEach(label => {
			if (label in labelsSet && !addedLabels.includes(label)) {
				l.push(labelsSet[label])
				addedLabels.push(label)
			}
		})
	}

	return {
		key: timeSlot.key,
		startTime: timeSlot.start_time,
		endTime: timeSlot.end_time,
		worker: {
			id: timeSlot.worker_details.worker_contract_id,
			firstName: timeSlot.worker_details.first_name,
			lastName: timeSlot.worker_details.last_name,
			affiliateId: timeSlot.worker_details.affiliate_id,
			affiliateName: timeSlot.worker_details.affiliate_name,
			title: timeSlot.worker_details.title,
		},
		labels: l
	}
}


// WEBPACK FOOTER //
// ./src/normalizers/bookingFlowNormalizers.js